// Safe localStorage wrapper for sort preferences.
//
// localStorage may throw in private browsing or when quota is exceeded;
// every read/write is wrapped in a try/catch and silently falls back to
// the supplied defaults / a no-op so the component never crashes.

function storageKey(scope) {
  return `tasks-sort-${scope}`
}

export function loadSortPref(scope, defaults) {
  try {
    const raw = window.localStorage.getItem(storageKey(scope))
    if (!raw) return defaults
    const parsed = JSON.parse(raw)
    if (!parsed || typeof parsed !== 'object') return defaults
    return {
      field: parsed.field ?? defaults.field,
      direction: parsed.direction === 'desc' ? 'desc' : 'asc',
    }
  } catch {
    return defaults
  }
}

export function saveSortPref(scope, value) {
  try {
    window.localStorage.setItem(storageKey(scope), JSON.stringify(value))
  } catch {
    // ignore — fall back to in-memory state
  }
}
